import script from "./SideNotificationsVue.vue?vue&type=script&lang=ts&setup=true"
export * from "./SideNotificationsVue.vue?vue&type=script&lang=ts&setup=true"

import "./SideNotificationsVue.vue?vue&type=style&index=0&id=fb832b56&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb832b56"]])

export default __exports__